export const preferences = {
  mode: "モード",
  text: "テキスト",
  translationFeature: "翻訳機能",
};
